import { create } from 'zustand';
import type { OrgEntitlements } from '@court-sync/shared';
import { buildOrgEntitlements } from '@court-sync/shared';
import { clubService } from '@/services/club';

interface ClubModuleAccessState {
  entitlements: OrgEntitlements | null;
  isLoading: boolean;
  error: string | null;
  fetchPromise: Promise<void> | null;
  refresh: () => Promise<void>;
  reset: () => void;
}

export const useClubModuleAccessStore = create<ClubModuleAccessState>((set, get) => ({
  entitlements: null,
  isLoading: false,
  error: null,
  fetchPromise: null,

  refresh: async () => {
    const inFlight = get().fetchPromise;
    if (inFlight) {
      await inFlight;
      return;
    }

    set({ isLoading: true, error: null });

    const promise = (async () => {
      try {
        const response = await clubService.getOrganizationEntitlements();
        set({
          entitlements:
            response.success && response.data
              ? response.data
              : buildOrgEntitlements({ clubManagement: false, tier: 'starter' }),
        });
      } catch (err) {
        set({
          entitlements: buildOrgEntitlements({ clubManagement: false, tier: 'starter' }),
          error: err instanceof Error ? err.message : 'Failed to load club entitlements',
        });
      } finally {
        set({ isLoading: false, fetchPromise: null });
      }
    })();

    set({ fetchPromise: promise });
    await promise;
  },

  reset: () => {
    set({
      entitlements: null,
      isLoading: false,
      error: null,
      fetchPromise: null,
    });
  },
}));
